export default {
  is_date_after: '終了日は開始日より前の日付で登録できません。',
  is_less_than_max: '最小値に最大値より大きい値で登録できません。',
  at_least_one: '商品を1つ以上選択してください。',
  type_haft_with: '半角のみ入力できます。',
  type_haft_with_number: '半角数字のみ入力できます。',
};
